module.exports = __webpack_public_path__ + "static/media/DoorDashProviderLogo.52b209d0.png";